/* @jsx h */
import { defineComponent, h } from "vue";
import { CheckoutSheet } from "./CheckoutSheet/index";
import { onMounted } from "vue";
import {} from "../../providers";

export const ShopCheckoutPage = defineComponent({
  setup() {
    onMounted(() => {
      // Cart setup is now handled by parent ShopGroupOrder component
      document.body.scrollIntoView();
    });

    return () => {
      return (
        <div class="">
          <CheckoutSheet />
        </div>
      );
    };
  },
});
